<template>
  <v-container>
    <v-alert type="warning" text dismissible>
      Calculator is using floating point numbers with limited precision.<br />
      Percentages and ratios are rounded to a cent.
    </v-alert>

    <v-form>
      <v-text-field
        ref="capital"
        v-model="capital"
        v-on:input="emmitInput()"
        v-on:keydown.enter="$refs.risk.focus()"
        v-on:focus="$event.target.select()"
        type="number"
        label="Capital"
        prefix="$"
        clearable
      />

      <v-text-field
        ref="risk"
        v-model="risk"
        v-on:input="emmitInput()"
        v-on:keydown.enter="$refs.stopLoss.focus()"
        v-on:focus="$event.target.select()"
        type="number"
        min="0.00"
        step="0.25"
        max="100"
        label="Risk"
        suffix="%"
        autofocus
      />

      <v-text-field
        ref="stopLoss"
        v-model="stopLoss"
        v-on:input="emmitInput()"
        v-on:keydown.enter="$refs.entry.focus()"
        v-on:focus="$event.target.select()"
        type="number"
        label="Stop-Loss"
        prefix="$"
        clearable
      />

      <v-text-field
        ref="entry"
        v-model="entry"
        v-on:input="emmitInput()"
        v-on:keydown.enter="$refs.takeProfit.focus()"
        v-on:focus="$event.target.select()"
        type="number"
        label="Entry"
        prefix="$"
        clearable
      />

      <v-text-field
        ref="takeProfit"
        v-model="takeProfit"
        v-on:input="emmitInput()"
        v-on:keydown.enter="$refs.capital.focus()"
        v-on:focus="$event.target.select()"
        type="number"
        label="Take-Profit"
        prefix="$"
        clearable
      />

      <v-text-field
        readonly
        label="Position Size"
        :value="positionSize"
        prefix="$"
      />

      <v-alert type="info" text v-if="positionSize > capital">
        You will need
        <strong>{{ Math.ceil(positionSize / capital) }}&times; leverage</strong>
        to fully utilize the risk.
      </v-alert>

      <v-text-field
        v-model="riskAmount"
        label="Potential Loss"
        readonly
        prefix="$"
        class="red--text"
      />

      <v-text-field readonly label="Ratio" v-model="riskRewardRatio">
        <template v-slot:append>
          &times;
        </template>
      </v-text-field>

      <v-text-field
        readonly
        label="Potential Gain"
        v-model="rewardAmount"
        class="green--text"
        prefix="$"
      />
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "Calculator",
  props: ["value"],

  data() {
    return {
      // defaults
      capital: 10000,
      risk: 1,
      entry: null,
      stopLoss: null,
      takeProfit: null,

      ...this.value
    };
  },
  methods: {
    emmitInput() {
      this.$emit("input", {
        capital: this.capital,
        risk: this.risk,
        stopLoss: this.stopLoss,
        entry: this.entry,
        takeProfit: this.takeProfit
      });
    }
  },
  computed: {
    riskAmount() {
      if (!this.capital) {
        return null;
      }
      return this.capital * (this.risk / 100);
    },
    long() {
      return this.entry > this.stopLoss;
    },
    short() {
      return !this.long;
    },
    entryStopLossDistance() {
      return (
        Math.round(10000 * Math.abs(this.stopLoss / this.entry - 1)) / 10000
      );
    },
    entryTakeProfitDistance() {
      return (
        Math.round(10000 * Math.abs(this.entry / this.takeProfit - 1)) / 10000
      );
    },
    positionSize() {
      if (!this.entryStopLossDistance) {
        return null;
      }
      return this.riskAmount / this.entryStopLossDistance;
    },
    riskRewardRatio() {
      if (!this.entry || !this.takeProfit || !this.stopLoss) {
        return null;
      }
      return (
        Math.round(
          100 *
            Math.abs(
              (this.entry - this.takeProfit) / (this.entry - this.stopLoss)
            )
        ) / 100
      );
    },
    rewardAmount() {
      if (!this.riskRewardRatio) {
        return null;
      }
      return this.riskRewardRatio * this.riskAmount;
    }
  }
};
</script>
